const server_url = "https://where-you-at-weather-server.onrender.com";

export default server_url;
